<template>
  <a-card class="card" :bodyStyle="{padding:'0px 20px 20px'}">
    <base-sub-title title="字典管理"/>
    <a-tree
      :treeData="treeData"
      :expandedKeys="expandedKeys"
      :selectedKeys="selectedKeys"
      @expand="handleExpand"
      @select="handleSelect"
    >
      <template #title="node">
        <icon-svg v-if="node.icon && node.icon.length > 2" :icon-class="node.icon" class="menu-icon"></icon-svg>
        <span>{{node.title}}</span>
      </template>
    </a-tree>

    <template #actions>
      <a-icon @click="createSysDictType" title="添加字典类型" type="plus" />
      <a-icon @click="editSysDictType" title="编辑字典类型" type="edit" />
      <a-icon @click="deleteSysDictType" title="删除字典" type="delete" />
    </template>

    <dialog-sys-dict-type
      :key="dialogKey"
      :visible.sync="dialogVisible"
      :sysDictType="sysDictType"
      @update:sysDictType="$emit('update:sysDictType', $event)"
      :isAdd="isAdd"
      @submitted="getTreeData"
    ></dialog-sys-dict-type>
  </a-card>
</template>

<script>
import DialogSysDictType from './DialogSysDictType'
import { dict } from '@/api'

export default {
  name: 'SysDictTypeTree',

  components: {
    DialogSysDictType
  },

  props: {
    sysDictType: [String, Object]
  },

  async mounted () {
    const initExpandedKeys = await this.getTreeData()
    this.expandedKeys = initExpandedKeys
    this.selectedKeys = initExpandedKeys
  },

  data () {
    return {
      treeData: [],
      expandedKeys: [],
      selectedKeys: [],
      dialogVisible: false,
      dialogKey: 0,
      isAdd: true,
      loading: false
    }
  },

  methods: {
    handleExpand (expandedKeys) {
      this.expandedKeys = expandedKeys
    },
    handleSelect (selectedKeys, { node: { selected, dataRef } }) {
      this.selectedKeys = selectedKeys.length ? selectedKeys : [dataRef.id]
      this.$emit('update:sysDictType', dataRef)
    },
    createSysDictType () {
      if (this.sysDictType.id !== '0') return this.$message.warn('请点击[字典类型]进行添加')
      this.dialogVisible = true
      this.dialogKey++
      this.isAdd = true
    },
    editSysDictType () {
      if (this.sysDictType.id === '0') return this.$message.warn('[字典类型]不可修改')
      this.dialogVisible = true
      this.dialogKey++
      this.isAdd = false
    },
    deleteSysDictType () {
      if (this.sysDictType.id === '0') return this.$message.warn('[字典类型]不可删除')
      this.$confirm({
        title: '请注意',
        content: `您确认要删除[${this.sysDictType.name}]这个字典类型吗？`,
        onOk: async () => {
          try {
            let { code, msg } = await dict.deleteSysDictType(this.sysDictType.id)
            if (code === 0) {
              this.$message.success('删除成功')
              this.$emit('update:sysDictType', {})
              this.getTreeData()
            } else {
              this.$message.error(msg || '删除失败')
            }
          } catch (e) {
            console.error(e.message || '删除失败')
          }
        },
        okText: '是',
        cancelText: '否'
      })
    },
    async getTreeData () {
      let { data } = await dict.getSysDictTypeTree()
      this.treeData = this.handleDeptTreeData(data)
      this.$emit('update:sysDictType', data[0])
      return [data[0].id]
    },
    handleDeptTreeData (tree) {
      for (let node of tree) {
        node.key = node.id
        node.title = node.name
        node.scopedSlots = {
          icon: 'icon',
          title: 'title'
        }
        if (node.children) node.children = this.handleDeptTreeData(node.children)
      }
      return tree
    }
  }
}
</script>

<style lang="less" scoped>
.dept-item {
  cursor: pointer;
  height: 45px;
  line-height: 45px;
  font-size: 16px;

  &:not(:last-child) {
    border-bottom: 1px solid #eee;
  }

  &.active {
    color: @main-color;
  }
}
</style>
